import { useTenant } from '@emerald-works-nova/auth'

export function useArkMode () {
  const tenant = useTenant()
  const isAdminMode = tenant && tenant.tenantKey === 'admin'
  const isClientMode = tenant && tenant.tenantKey !== 'admin'

  return {
    rootTenant: tenant,
    rootTenantPk: tenant?.pk,
    isAdminMode,
    isClientMode
  }
}
